import * as React from 'react';
import './ProjectInterested.css';
import Person from 'src/entities/Person';

export interface ProjectInterestedCardComponentProps {
  interestedUser: Person;
  profilePicture?: File;
}

class ProjectInterestedCardComponent extends React.Component<ProjectInterestedCardComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="item col-sm-6 col-md-4">

        <div className="simple-card user-card shadow">
          <div className="crop-image-simple-card">
            <img
              alt={this.props.interestedUser.displayName}
              src={this.props.profilePicture ?
                // tslint:disable-next-line:no-any
                (window.URL || (window as any).webkitURL).createObjectURL(this.props.profilePicture) :
                '/img/user-profile-big.png'
              }
            />
          </div>
          {this.props.interestedUser.linkedinProfile ?
            <a
              href={this.props.interestedUser.linkedinProfile}
              className="linkedin-badge"
              target="_blank"
            /> : null
          }
          <div className="user-content">
            <h5 className="deco-title">
              {this.props.interestedUser.displayName}
            </h5>
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }
}

export default ProjectInterestedCardComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-interested/ProjectInterestedCard.component.tsx